<template>
  <div id="" class="">
      <el-dialog title="创建优惠券" :visible.sync="isShowdialog" :before-close="cancel" width="30%">
        <el-form ref="form" label-width="110px" size="mini" >
          <el-row style="display: flex;justify-content: center">
            <el-col :span="20">
              <el-form-item label="优惠券名称">
                <el-input v-model="couponForm.couponName"></el-input>
              </el-form-item>
              <el-form-item label="优惠金额（元）">
                <el-input v-model="couponForm.couponPrice"></el-input>
              </el-form-item>
              <el-form-item label="满足使用金额（0为无门槛）">
                <el-input v-model="couponForm.usePrice"></el-input>
              </el-form-item>
              <el-form-item label="批次有效天数">
                <el-input v-model="couponForm.expireDay"></el-input>
              </el-form-item>
              <!-- <el-form-item label="审核状态" required>
                <el-select v-model="audit" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row style="display:flex;justify-content: flex-end">
            <el-form-item size="mini">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cancel">取消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
  },
  data() {
    return {
      isShowdialog: false,
      dialogTitle: '',
      returnTime: '',
      uploading: '',
      options: [{
        value: '通过',
        label: '通过'
      }, {
        value: '未通过',
        label: '未通过'
      }],
      audit: '',
      couponForm: {
        couponName: '',
        couponPrice: 10,
        usePrice: 0,
        expireDay: 1
      }
    }
  },
  methods:{
    cancel(done){
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowdialog,dialog:'coupon'})
    },
    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });

      try{
        const coupon = await this.$request.set_message('coupons',this.couponForm);
        if(coupon.code === 0){
          this.$message('创建优惠券成功');
        }else{
          this.$message(coupon.errMsg);
        }
      } catch(e) {
        this.$message(e);
      } finally {
        this.uploading.close();
        this.isShowdialog = false;
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'audit',refresh:true})
      }
    },

  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/CreateCouponDialog.vue